//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {
    pageModule,
    categoryModule,
    newUserActivity,
    getNotifyByPageType,
    getPopCoupon,
    getCoupon,
    getSearchDefault,
    findEnterpriseWeChat,
    generatescheme,
    getLaxinConfig
  } from "@/api/index.js";
  import {
    getCookie
  } from "@/utils/auth.js";
  import Swiper from "swiper/swiper-bundle.min.js";
  import FloatImgBtn from "@/components/FloatImgBtn.vue"; //浮动标签
  import {
    List,
    PullRefresh,
    Sticky,
    Overlay,
    Loading
  } from "vant";
  import TabBar from "@/components/footer";
  export default {
    data() {
      return {
        pageData: {},
        currentTabIndex: 0, //选中tab的index
        currentTabCid: "", //商品分类的cid
        currentTabTitle: "", //选中tab的title
        pageSize: 10, //每页数据
        offset: 1, //当前页数
        categoryList: [], //分类商品
        list: [],
        loading: false,
        finished: false,
        refreshing: false,
        headerFixed: false,
        showFloating: false,
        catEmpty: false,
        showLoading: true, //页面加载loading
        index_popup_url: "",
        new_user_page_header_url: "",
        new_user_page_popup_url: "",
        new_user_gift_url: "",
        order_unlock_popup_url: "",
        index_url: "",
        bindStatus: false, //是否领取   默认未领取
        showNewComer: false, //显示首页弹层
        showPulicNotice: false, //打开未关注公众号弾图配置
        tipImgSrc: "", //提示未关注公众号图片
        redirectUrl: "", //跳转地址
        informText: "",
        deliveryType: null, //优惠券类型
        c_imgUrl: "", //图片弹层 img地址
        c_jumpUrl: "", //图片弹层 跳转地址
        showPopCoupon: false, //图片弹层状态
        couponBatchs: [], //优惠券弹层 优惠券列表
        c_name: "", //优惠券弹层 名称
        c_explains: "", //优惠券弹层 描述
        c_status: "", //优惠券弹层状态
        c_deliveryId: "", //优惠弹层id
        c_de: null,
        goodName:"",//默认搜索词
        showWeChat:false,//是否加微信好友
        showOldWeChat:false,
        showBottomWeChat:false,//底部显示是否加好友
        showOldBottomWeChat:false,//已经加V好友
        URL_Scheme:"",//跳转地址
        showSwiperStatus:true,//加V弹窗
        currentPopCoupon:null,
        imgsrc:"",
        laxinImg:"",
        laxinUrl:"",
        lipinkaAppid:"wxb8e1234c4bd0b7e4",//礼品卡
        shopAppid:"wx3b8f20b180312e78"//商城
      };
    },

    components: {
      List: List,
      [PullRefresh.name]: PullRefresh,
      [Sticky.name]: Sticky,
      TabBar,
      [Overlay.name]: Overlay,
      [Loading.name]: Loading,
      FloatImgBtn
    },

    computed: {},

    created() {
      this.getPageModule();
      this.getNotify();
      this.getSearchDefaultFun();
    },

    mounted() {
      this.swiperobj();
      // handleScroll为页面滚动的监听回调
      window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    },

    methods: {
      //获取小程序跳转链接
      generateschemeFun:function(url,appid){
        let that = this;
        let params = {
        	miniAppId: appid,
        	path: url
        };
        generatescheme(params).then(res=>{
          if (res.errcode == 0 && res.openlink != "") {
            console.log("res.openlink------",res.openlink)
            window.location.href = res.openlink;
          }else{

          }
        })
      },





      //获取搜索词默认词和本周限购
      getSearchDefaultFun() {
        let that = this;
        getSearchDefault().then(res=>{
          if(res.status == 1){
            that.goodName = res.result.default1;
          }
        })
      },
      isFiexed(isFiexed) {
        console.log(isFiexed, "isFiexed");
        var box = document.querySelector(".goods-list");
        console.log(box, "box");
      },
      handleScroll() {
        // 得到页面滚动的距离
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        // 判断页面滚动的距离是否大于吸顶元素的位置

        this.headerFixed =
          scrollTop > this.offsetTop + this.offsetHeight * 2 + 15;
        if (scrollTop > 300) {
          this.showFloating = true;
        } else {
          this.showFloating = false;
        }
        // console.log(scrollTop,this.offsetTop,this.offsetHeight)
        // console.log(this.headerFixed ,'this.headerFixed ')
      },
      onLoad() {
        this.offset++;
        this.getCategoryModule();
      },
      onRefresh() {
        this.getCategoryModule();
      },
      getPageModule(type) {
        pageModule().then((res) => {
          let pageData = res.data;
          let informText = ""
          pageData.modulePageInfoList.map((item) => {
            item.content = JSON.parse(item.content);
            if (item.moduleType == 5 && item.isShow == 1) {
              item.content.titles.map((item1) => {
                item1.active = false;
              });
              //默认选中第一个tab
              this.currentTabCid = item.content.titles[0].cid;
              this.currentTabTitle = item.content.titles[0].title
              item.content.titles[0].active = true;
              this.getCategoryModule();
            } else if (item.moduleType == 6) {
              informText = item.content.text.replace(/\n/g, '')
            }
          })
            // let likeObj = {
         		// 	content: {
            //     pictures: [
            //       {
            //         picUrl: this.likeImg,
            //         picDesc: "",
            //         picRedirectUrl: "../newcomersList/index",
            //         redirectType: 1,
            //       },
            //     ],
            //     picNum: 1,
            //   },
            //   createByName: "admin",
            //   createTime: null,
            //   id: null,
            //   isShow: 1,
            //   moduleDesc: "",
            //   modulePageId: 20,
            //   moduleTitle: "",
            //   moduleType: 7,
            //   priority: 2,
            //   updateByName: "admin",
        		// 	};
		        // let moduleLen = pageData.modulePageInfoList.length
		        // pageData.modulePageInfoList.splice(3, 0,likeObj)

          this.pageData = pageData;
          console.log(this.pageData, "this.pageData");

          //记录第一次进入的来源
          let first_utm_source = localStorage.getItem("first_utm_source")
          if(first_utm_source == "" || first_utm_source == null || first_utm_source == "undefined"){
            localStorage.setItem("first_utm_source",this.pageData.suffix)
          }


          this.$nextTick(() => {
            this.swiperobj();
          });
          //loading隐藏
          this.showLoading = false
          this.$nextTick(function() {
            // 这里fixedHeaderRoot是吸顶元素的ID
            let header = document.getElementById("tabBox");
            if (header != undefined) {
              // 这里要得到top的距离和元素自身的高度
              this.offsetTop = header.offsetTop;
              this.offsetHeight = header.offsetHeight;
              console.log(
                "offsetTop:" + this.offsetTop + "," + this.offsetHeight
              );
            } else {
              window.removeEventListener("scroll", this.handleScroll);
            }

            console.log(informText, 'informText')
            if (informText != "") {
              this.informText = informText
              this.informScroll();
            }

          });

          //请求新人活动
          this.getNewUserActivity();

          //请求是否加微信好友
          this.findEnterpriseWeChatFun();
        });
      },
      //点击搜索
      goSearch() {
        // window.location.href = process.env.PRODUCTURL + "/goodsSearch";
        this.$router.push('/goodsSearch')
      },
      //返回顶部
      goTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      },
      goProduct(item, index, item1, index1) {
        console.log("轮播图点击----------");
        let ModuleTypes = [
          "banner",
          "图片模块",
          "主题组合模块",
          "专题模块",
          "信息流模块",
        ];

        let sortNum = index + 1;
        //如果有新人活动模块  sortNum  从第二个开始  不加1  为了和没有新人专享的神策埋点数据一致
        if (this.index_url != "" && index >= 2) {
          sortNum = index;
        } else {
          sortNum = index + 1;
        }
        //神策
        if (item.moduleType == 0) {
          sa.track("position_Click", {
            platform_type: "H5",
            page_name: "首页",
            belong_page: location.href,
            module_type: "banner",
            module_sort: sortNum + "",
            operat_type: "图片",
            element_name: "banner_" + (index1 + 1),
            urt: item1.picRedirectUrl + "",
            page_id: this.pageData.id,
            module_name: "",
          });
        } else if (
          item.moduleType == 1 &&
          item1.picRedirectUrl.indexOf("newcomersList") < 0
        ) {
          sa.track("position_Click", {
            platform_type: "H5",
            page_name: "首页",
            belong_page: location.href,
            module_type: "图片模块",
            module_sort: sortNum + "",
            operat_type: "图片",
            element_name: "picture_" + (index1 + 1),
            urt: item1.picRedirectUrl + "",
            page_id: this.pageData.id,
            module_name: item.moduleTitle,
          });
        } else if (item.moduleType == 2) {
          sa.track("position_Click", {
            platform_type: "H5",
            page_name: "首页",
            belong_page: location.href,
            module_type: "主题组合模块",
            module_sort: sortNum + "",
            operat_type: "图片",
            element_name: "theme_" + (index1 + 1),
            urt: item1.picRedirectUrl + "",
            page_id: this.pageData.id,
            module_name: item.moduleTitle,
          });
        } else if (item.moduleType == 4) {
          sa.track("position_Click", {
            platform_type: "H5",
            page_name: "首页",
            belong_page: location.href,
            module_type: "专题模块",
            module_sort: sortNum + "",
            operat_type: "商品",
            element_name: item1.title,
            urt: item1.pageUrl,
            page_id: this.pageData.id,
            module_name: item.moduleTitle,
          });
        } else if (item.moduleType == 5) {
          sa.track("position_Click", {
            platform_type: "H5",
            page_name: "首页",
            belong_page: location.href,
            module_type: "信息流模块",
            module_sort: sortNum + "",
            operat_type: "商品",
            element_name: item1.name,
            urt: item1.goodsCode,
            page_id: this.pageData.id,
            module_name: this.currentTabTitle,
          });
        }

        // if(type == 0){
        if (item.moduleType == 4) {
          //专题页跳转礼品卡小程序
          if(item.content.toGiftMini){
            let url = '/pages/productPage/productPage?gid=' + item1.goodsCode + "&utm_source=" + item.content.suffix;
            this.generateschemeFun(url,this.lipinkaAppid)
            return
          }
          //如果是老的商品详情地址
          if(item1.pageUrl.indexOf("/detail/") > 0){
            let strArr = item1.pageUrl.split("/detail/");
            if(strArr.length>1){
              if(strArr[1].indexOf("?") > 0){
                let str_gidArr = strArr[1].split("?");
                let str_gid = str_gidArr[0];
                window.location.href =
                  process.env.PAGEURL +
                  "/goodDetails?gid=" +
                  str_gid +
                  "&utm_source=" +
                  this.pageData.suffix;
              }
            }
          }else{
            if(item1.pageUrl == "" && item1.goodsCode != ""){
              //新商品集合页
              //新的商品详情地址
              console.log('新商品集合页商品详情地址--------')
              if(item.content.suffix != undefined && item.content.suffix != null && item.content.suffix != ""){
                window.location.href =
                  process.env.PAGEURL +
                  "/goodDetails?gid=" +
                  item1.goodsCode +
                  "&utm_source=" +
                  item.content.suffix;
              }else{
                window.location.href =
                  process.env.PAGEURL +
                  "/goodDetails?gid=" +
                  item1.goodsCode +
                  "&utm_source=" +
                  this.pageData.suffix;
              }
            }else{
              //新的商品详情地址
              window.location.href =
                item1.pageUrl + "?utm_source=" + this.pageData.suffix;
            }

          }
        } else if (item.moduleType == 5) {
          window.location.href =
            process.env.PAGEURL +
            "/goodDetails?gid=" +
            item1.goodsCode +
            "&utm_source=" +
            this.pageData.suffix;
        } else {
          console.log(item1, "item1");
          if (item1.redirectType == 1) {
            if(item1.picRedirectUrl.indexOf("pages/buyItNow") > -1){
              this.generateschemeFun(item1.picRedirectUrl,this.shopAppid);
            }else{
              if (item1.picRedirectUrl.indexOf("?") == -1) {
                // console.log(item1.picRedirectUrl.indexOf("guessLike") >= 0,'22')
                // return
                // 如何是新人专享入口
                if (item1.picRedirectUrl.indexOf("newcomersList") >= 0) {
                  this.$router.push({
                    path: "/newcomersList",
                    query: {
                      new_user_page_popup_url: this.new_user_page_popup_url,
                      new_user_gift_url: this.new_user_gift_url,
                      order_unlock_popup_url: this.order_unlock_popup_url,
                      new_user_page_header_url: this.new_user_page_header_url,
                      bindStatus: this.bindStatus,
                    },
                  });
                  sa.track("Newuserposition_click", {
                    page_name: "首页",
                    belong_page: location.href,
                  });
                }else if(item1.picRedirectUrl.indexOf("wxsphzb") >= 0){
                  let nUrl = item1.picRedirectUrl.replace("wxsphzb=", "");
                  window.location.href = nUrl;
                }else if(item1.picRedirectUrl.indexOf("wxsphyy") >= 0){
                  let nUrl = item1.picRedirectUrl.replace("wxsphyy=", "");
                  window.location.href = nUrl;
                }else if(item1.picRedirectUrl.indexOf("guessLike") >= 0){
                  let utm_source = "";
                  if(item1.picRedirectUrl.indexOf("?utm_source") >= 0){
                    let sourceArr = item1.picRedirectUrl.split("?utm_source=");
                    if(sourceArr.length > 1){
                      utm_source = sourceArr[1];
                    }
                  }else{
                    utm_source = this.pageData.suffix;
                  }
                  window.location.href =
                    process.env.PAGEURL +
                    "/guessLike?utm_source=" +
                    utm_source;
                }else {
                  //如果是集合页  或者  cms页  不带后缀进入
                  if(item1.picRedirectUrl.indexOf("customer/#/richPage") >= 0 || item1.picRedirectUrl.indexOf("cmsPage?pageId") >= 0){
                    window.location.href = item1.picRedirectUrl;
                  }else{
                    window.location.href =
                      item1.picRedirectUrl + "?utm_source=" + this.pageData.suffix;
                  }
                }
              } else {
                if(item1.picRedirectUrl.indexOf("shoppingGold") >= 0){
                  let utm_source = "";
                  if(item1.picRedirectUrl.indexOf("?utm_source") >= 0){
                    let sourceArr = item1.picRedirectUrl.split("?utm_source=");
                    if(sourceArr.length > 1){
                      utm_source = sourceArr[1];
                    }
                  }else{
                    utm_source = this.pageData.suffix;
                  }
                  window.location.href =
                    process.env.PAGEURL +
                    "/shoppingGold?utm_source=" +
                    utm_source;
                }else if(item1.picRedirectUrl.indexOf("guessLike") >= 0){
                  let utm_source = "";
                  if(item1.picRedirectUrl.indexOf("?utm_source") >= 0){
                    let sourceArr = item1.picRedirectUrl.split("?utm_source=");
                    if(sourceArr.length > 1){
                      utm_source = sourceArr[1];
                    }
                  }else{
                    utm_source = this.pageData.suffix;
                  }
                  window.location.href =
                    process.env.PAGEURL +
                    "/guessLike?utm_source=" +
                    utm_source;
                } else{
                  //如果是集合页  或者  cms页  不带后缀进入
                  if(item1.picRedirectUrl.indexOf("customer/#/richPage") >= 0 || item1.picRedirectUrl.indexOf("cmsPage?pageId") >= 0){
                    window.location.href = item1.picRedirectUrl;
                  }else{
                    window.location.href =
                      item1.picRedirectUrl + "&utm_source=" + this.pageData.suffix;
                  }
                }

              }
            }

          } else if (item1.redirectType == 2){
            console.log("跳转小程序----------");
            this.generateschemeFun(item1.picRedirectUrl,this.lipinkaAppid);
          } else if (item1.redirectType == 3) {
            window.location.href =
              process.env.PAGEURL +
              "/goodDetails?gid=" +
              item1.goodsCode +
              "&utm_source=" +
              this.pageData.suffix;
          }
        }

        // }
        // console.log(item1, type);
      },
      //专题查看更多
      lookMore(item, index) {
        //神策
        sa.track("position_Click", {
          platform_type: "H5",
          page_name: "首页",
          belong_page: location.href,
          module_type: "专题模块",
          module_sort: index + 1 + "",
          operat_type: "按钮",
          element_name: "查看更多",
          urt: process.env.PAGEURL +
            "/page" +
            item.content.collectionPageUrl +
            ".html" +
            "?utm_source=" +
            this.pageData.suffix,
          page_id: this.pageData.id,
          module_name: item.moduleTitle,
        });
        //自定义跳转
        if (item.content.collectionPageCustom) {
          window.location.href = item.content.collectionPageCustom;
        } else {
           //专题页跳转礼品卡小程序
          if(item.content.toGiftMini){
            let url = "pages/newAllreflower/index?pageId=" + item.content.collectionPageUrl
            this.generateschemeFun(url,this.lipinkaAppid)
            return
          }
          if(item.content.pageType == "newPage"){
            // window.location.href =
            //   process.env.PAGEURL +
            //   "/cmsPage?pageId=" +
            //   item.content.collectionPageUrl +
            //   "&utm_source=" +
            //   this.pageData.suffix;
              window.location.href =
                process.env.PAGEURL +
                "/cmsPage?pageId=" +
                item.content.collectionPageUrl;
          }else{
            window.location.href =
              process.env.PAGEURL +
              "/page" +
              item.content.collectionPageUrl +
              ".html" +
              "?utm_source=" +
              this.pageData.suffix;
          }

        }
      },
      //去猜你喜欢
      goGuess() {
      		this.$router.push('/guessLike')
    		},
      //选择tab
      checkTab(item, index, item1, index1) {
        item.content.titles.map((item3) => {
          item3.active = false;
        });
        item1.active = true;
        this.currentTabCid = item1.cid;
        this.currentTabTitle = item1.title;
        this.offset = 1;
        this.finished = false;
        this.getCategoryModule(1);
        this.$nextTick(() => {
          // document.documentElement.scrollTop = document.body.scrollTop = this.offsetTop
          let header = document.getElementById("tabBox");
          //  window.scrollTo(0,(this.offsetTop+this.offsetHeight*2+15))
        });
        //神策
        sa.track("position_Click", {
          platform_type: "H5",
          page_name: "首页",
          belong_page: location.href,
          module_type: "信息流模块",
          module_sort: index + 1 + "",
          operat_type: "tab",
          element_name: item1.title,
          urt: item1.cid,
          page_id: this.pageData.id,
          module_name: "",
        });
      },
      //分类商品
      getCategoryModule(type) {
        let params = {
          cid: this.currentTabCid,
          pageSize: this.pageSize,
          pageNo: this.offset,
        };
        categoryModule(params).then((res) => {
          let data = res.data;
          this.loading = false;
          if (type == 1) {
            this.categoryList = data.result;
            this.$nextTick(() => {
              window.scrollTo(0, this.offsetTop);
            });
          } else {
            this.categoryList = this.categoryList.concat(data.result);
          }
          if (this.offset >= data.totalPage) {
            this.finished = true;
            console.log(111111);
          }
        });
      },
      //swiper
      swiperobj() {
        var swiper = new Swiper(".swiper", {
          pagination: {
            el: ".swiper-pagination",
            // clickable: true,
          },
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          observer: true,
          lazyLoading: true,
        });
        // return swiper;
      },
      swiperObjCoupon(initialSlide) {
        let that = this
        var swiper = new Swiper(".swiperCoupon", {
          pagination: {
            el: ".swiper-pagination-coupon",
            clickable: true,
          },
          loop: true,
          initialSlide:initialSlide,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          observer: true,
          lazyLoading: true,
          on: {
              click: (event) =>  {
                console.log(event.realIndex,'event.realIndex')
                console.log(that.c_jumpUrl,'that.c_jumpUrl')

                  if (event.realIndex== 0) {
                      that.gotoCouponFun(that.c_jumpUrl)
                  }else{
                    that.addWechatFun()
                  }
              }
          }



        });
      },

      // 获取新人专享活动
      getNewUserActivity: function() {
        let hdu = getCookie("hdu");
        let hdt = getCookie("hdt");
        let _this = this;
        newUserActivity(hdu).then((res) => {
          console.log("新人专享返回---------", res);
          if (res.code == 1 && res.data != null) {
            _this.index_url = res.data.index_url;

            _this.index_popup_url = res.data.index_popup_url;
            _this.new_user_page_header_url = res.data.new_user_page_header_url;
            _this.new_user_page_popup_url = res.data.new_user_page_popup_url;
            _this.new_user_gift_url = res.data.new_user_gift_url;
            _this.order_unlock_popup_url = res.data.order_unlock_popup_url;
            _this.bindStatus = res.data.bindStatus;
            //是否领取
            if (!res.data.bindStatus) {
              _this.showNewComer = true;
              sa.track("notice_show", {
                notice_type: "首页红包",
                page_name: "首页",
                belong_page: location.href,
              });
            }
            if (_this.index_url != "" && _this.index_url != null) {
              //如果有地址，添加到列表中
              let newPageData = _this.pageData;
              let obj = {
                content: {
                  pictures: [{
                    picUrl: _this.index_url,
                    picDesc: "",
                    picRedirectUrl: "../newcomersList/index",
                    redirectType: 1,
                  }, ],
                  picNum: 1,
                },
                createByName: "admin",
                createTime: null,
                id: null,
                isShow: 1,
                moduleDesc: "",
                modulePageId: 20,
                moduleTitle: "",
                moduleType: 1,
                priority: 2,
                updateByName: "admin",
              };
              //有无通知模块
              let hasInformModule = false
              newPageData.modulePageInfoList.map(item => {
                if (item.moduleType == 6) {
                  hasInformModule = true
                }
              })
              if (hasInformModule) {
                newPageData.modulePageInfoList.splice(2, 0, obj);
              } else {
                newPageData.modulePageInfoList.splice(1, 0, obj);
              }

              _this.pageData = newPageData;

              console.log("pageData-----------", _this.pageData);
              sa.track("Newuserposition_show", {
                page_name: "首页",
                belong_page: location.href,
              });
            }
          }else{
            _this.getPopCouponFun(); //获取优惠券弹窗
            _this.getLaxinConfigFun();
          }
        });
      },

      // 进入新人专享列表
      gotoNewComerFun: function() {
        sa.track("notice_click", {
          notice_type: "首页红包",
          page_name: "首页",
          belong_page: location.href,
          click_type: 1,
        });
        this.showNewComer = false; //关闭弹层
        this.$router.push({
          path: "/newcomersList",
          query: {
            new_user_page_popup_url: this.new_user_page_popup_url,
            new_user_gift_url: this.new_user_gift_url,
            order_unlock_popup_url: this.order_unlock_popup_url,
            new_user_page_header_url: this.new_user_page_header_url,
            bindStatus: this.bindStatus,
          },
        });
      },
      // 关闭新人大礼包界面
      closePopupFun: function() {
        this.showNewComer = false;
        //首页红包点击埋点
        sa.track("notice_click", {
          notice_type: "首页红包",
          page_name: "首页",
          belong_page: location.href,
          click_type: 0,
        });
      },
      getNotify() {
        let hdu = getCookie("hdu");
        if (hdu != "" && hdu != null && hdu != undefined) {
          let cache = localStorage.getItem("OFFICIAL-ACCOUNT-TIP");
          if (this.isToday(cache)) return;
          getNotifyByPageType(hdu).then(res => {
            console.log(res, 'res')
            if (res.result != null) {
              this.showPulicNotice = true
              this.tipImgSrc = res.result.picUrl
              this.redirectUrl = res.result.redirectUrl //跳转地址
            }
          })
        }
      },
      gotoPulicNoticeFun() {
        // this.picturenoticeClick(1)
        // window.location.href = this.redirectUrl
        sa.track("addWechatClick", {
          platform_type: "H5",
          belong_page: location.href,
        	type_name:"首页底部导航",
        	type_url:"https://m.reflower.com.cn/customer/#/richPage?id=5085"
        });
        window.location.href = encodeURI("https://m.reflower.com.cn/customer/#/richPage?id=5085");
      },
      gotoOldPulicNoticeFun() {
        // this.picturenoticeClick(1)
        // window.location.href = this.redirectUrl
        sa.track("addWechatClick", {
          platform_type: "H5",
          belong_page: location.href,
        	type_name:"首页底部导航",
        	type_url:"https://mp.weixin.qq.com/s/GEzJyh3PSviychghjK9n1Q"
        });
        window.location.href = encodeURI("https://mp.weixin.qq.com/s/GEzJyh3PSviychghjK9n1Q");
      },
      //关闭公众号提示
      closePulicNoticeFun() {
        //记录本地缓存
        // localStorage.setItem("OFFICIAL-ACCOUNT-TIP", +new Date())
        // //神策
        // this.picturenoticeClick(0)
        // this.showPulicNotice = false
        this.showBottomWeChat = false;
        this.showOldBottomWeChat = false;
      },
      isToday(date) {
        if (date) {
          return date.toString().slice(0, 6) === Date.parse(new Date()).toString().slice(0, 6);
        } else {
          return false;
        }

      },
      //神策 关注公众号点击埋点
      picturenoticeClick(clickType) {
        var params = {
          referrer: '', // 前向地址
          belong_page: window.location.href, //当前页面url
          page_name: "商城首页",
          click_type: clickType,
        };
        sa.track("PicturenoticeClick", params);
      },
      //查看通知
      goInformDetail(index) {
        //神策
        sa.track("position_Click", {
          platform_type: "H5",
          page_name: "首页",
          belong_page: location.href,
          module_type: "通知模块",
          module_sort: index + 1 + "",
          operat_type: "",
          element_name: '通知条',
          urt: location.href + '/inform',
          page_id: this.pageData.id,
          module_name: "",
        });
        this.$router.push('/inform')
      },
      //通知滚动
      informScroll() {
        var speed = 40;
        var tab = document.getElementById("demos");
        var tab1 = document.getElementById("demo1");
        var tab2 = document.getElementById("demo2");
        tab2.innerHTML = tab1.innerHTML;
        console.log(11111);
        var MyMar = setInterval(() => {
          if (tab2.offsetWidth - tab.scrollLeft <= 0)
            tab.scrollLeft -= tab1.offsetWidth;
          else {
            tab.scrollLeft++;
          }
        }, speed);
        this.$once("hook:beforeDestroy", () => {
          clearInterval(MyMar);
          MyMar = "";
        });
      },
      //获取优惠券弹窗
      getPopCouponFun: function() {
        let hdu = getCookie("hdu");
        let hdt = getCookie("hdt");
        let _this = this;
        let currenturl = "https://sale.reflower.com.cn"; //window.location.href;
        if (currenturl.substr(currenturl.length - 1, 1) == '/') {
          currenturl = currenturl.substr(0, currenturl.length - 1)
        }
        let evenNum = _this.getOddEvenFun(hdu);//true  是偶数
        if(evenNum){
          this.currentPopCoupon = 1
        }else{
          this.currentPopCoupon = 0
        }

        // this.showSwiperStatus = true;

        getPopCoupon(currenturl,hdu).then((res) => {
          console.log("获取优惠券弹窗返回---------", res);
          let _this = this;
          if (res.code == 1 && res.data != "") {
            var data = JSON.parse(res.data);
            console.log("data---------", data);


            _this.deliveryType = data.deliveryType;


            let evenNum = _this.getOddEvenFun(hdu);//true  是偶数
            let initialSlide;
            if(evenNum){
              initialSlide = 1
            }else{
              initialSlide = 0
            }
            setTimeout(()=>{
              this.swiperObjCoupon(initialSlide);
              _this.showPopCoupon = true;
            },800)


            //图片弹层提示框
            if (data.deliveryType == 3) {
              _this.c_imgUrl = data.imgUrl;
              _this.c_jumpUrl = data.jumpUrl;
              sa.track("notice_show", {
                notice_type: "推广位弹框",
                page_name: "首页",
                belong_page: location.href,
              });
            } else if (data.deliveryType == 2) {
              if (res.desc != undefined) {
                _this.c_de = JSON.parse(res.desc);
              } else {
                _this.c_de = "";
              }
              //优惠券弹层
              _this.couponBatchs = data.couponBatchs
              _this.c_name = data.name;
              _this.c_explains = data.explains;
              _this.c_status = data.status;
              _this.c_deliveryId = data.id;
            }

          }
        });
      },

      //判断uid是奇数还是偶数
      getOddEvenFun: function (uid) {
          let num = parseFloat(uid);
          if (num % 2 === 0) {
            //偶数
            return true;
          } else if (num % 2 === 1) {
            //奇数
            return false;
          }
        },
      // 关闭优惠券弹窗
      closedPopCoupon: function() {
        console.log("111")
        if(this.deliveryType == 3){
          sa.track("notice_click", {
            notice_type: "推广位弹框",
            page_name: "首页",
            belong_page: location.href,
            click_type: 0,
          });
        }

        this.showPopCoupon = false;
        // this.showSwiperStatus = false;
      },
      //图片弹窗优惠券跳转地址
      gotoCouponFun:function(couponUrl){
        this.showPopCoupon = false;
        console.log(couponUrl,'couponUrl')
        sa.track("notice_click", {
          notice_type: "推广位弹框",
          page_name: "首页",
          belong_page: location.href,
          click_type: 1,
        });
        if(couponUrl.indexOf("shoppingGold") >= 0){
          let utm_source = "";
          if(couponUrl.indexOf("?utm_source") >= 0){
            let sourceArr = couponUrl.split("?utm_source=");
            if(sourceArr.length > 1){
              utm_source = sourceArr[1];
            }
          }else{
            utm_source = this.pageData.suffix;
          }
          window.location.href =
            process.env.PAGEURL +
            "/shoppingGold?utm_source=" +
            utm_source;
        }if(couponUrl.indexOf("pages/buyItNow") > -1){
          this.generateschemeFun(couponUrl,this.shopAppid)
        }
        else{
          window.location.href = couponUrl;
        }

      },
      //优惠券弹层
      couponValueArry: function(value, num) {
        var valueStr = value + "";
        var valueArry = valueStr.split(".");
        if (valueArry[1] == undefined) {
          valueArry[1] = "";
        } else {
          valueArry[1] = "." + valueArry[1];
        };
        return valueArry[num];
      },
      //优惠券时间
      starttimeFilter: function(value) {
        var date = new Date(value);
        let Y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let H = date.getHours();
        let i = date.getMinutes();
        let s = date.getSeconds();
        if (m < 10) {
          m = '0' + m;
        }
        if (d < 10) {
          d = '0' + d;
        }
        if (H < 10) {
          H = '0' + H;
        }
        if (i < 10) {
          i = '0' + i;
        }
        if (s < 10) {
          s = '0' + s;
        }
        var t = Y + '-' + m + '-' + d + ' ';
        return t;
      },
      //获取优惠券领取状态
      getCouponStatus: function(item, status) {
        let statusTxt = ""; //按钮内容
        var click = "receive(2," + this.deliveryId + "," + item.couponBatchId + ")";
        var href = "javascript:void(0);";
        var couno = ""; //右侧样式
        var csssty = "im-use"; //按钮样式
        if (this.c_status == 1) {
          statusTxt = '未开始';
          couno = 'cou-no';
        } else {
          if (item.validType == 1) {
            if (item.endDate <= this.c_de.signTime) {
              statusTxt = '已过期';
              click = '';
              couno = 'cou-no';
            } else {
              if (item.leftNumber <= 0) {
                statusTxt = '已抢光';
                click = '';
                couno = 'cou-no';
              } else {
                statusTxt = '立即领取';
              }
            }
          } else if (item.validType == 2) {
            if (item.leftNumber <= 0) {
              statusTxt = '已抢光';
              click = '';
              couno = 'cou-no';
            } else {
              statusTxt = '立即领取';
            }
          }
          if (getCookie("hdu")) {
            if (item.bindByUid > 0 && item.bindByUid != undefined && item.bindByUid != "") {
              statusTxt = '立即使用';
              click = '';
              //如果是老的商品详情地址
              if(item1.pageUrl.indexOf("/detail/") > 0){
                let strArr = item1.pageUrl.split("/detail/");
                if(strArr.length>1){
                  if(strArr[1].indexOf("?") > 0){
                    let str_gidArr = strArr[1].split("?");
                    let str_gid = str_gidArr[0];
                    href = process.env.PAGEURL + "/goodDetails?gid=" + str_gid;
                  }
                }
              }else{
                //新的商品详情地址
                href = item.pageUrl;
              }
              couno = '';
              csssty = 'use'
            }
          }
        }
        if (status == "statusTxt") {
          return statusTxt;
        } else if (status == "click") {
          return click;
        } else if (status == "href") {
          return href;
        } else if (status == "couno") {
          return couno + " cou-right";
        } else if (status == "csssty") {
          return csssty;
        }
      },
      receive:function(n,deliveryId,batchId){
          var cousign = "";
          if(this.c_de.couponSign!=undefined){
              cousign = JSON.parse(this.c_de.couponSign);
          }else{
              cousign = "";
          }
          if(n == 1){
              var batchId = "";
              for (var key in cousign) {
                  batchId+= key.slice(3)+','
              }
              var batchIds = batchId.substring(0,batchId.length-1)
              var deliveryId = deliveryId;
              var sign = this.c_de.deliverySign;
              var signTime = this.c_de.signTime;
              var url = "/coupon/getAll";
              this.receivecoupon (n,deliveryId,batchIds,sign,signTime,url)
          }else{
              var sign = cousign['bid'+batchId];
              console.log(sign);
              /*立即领取*/
              var deliveryId = deliveryId;
              var batchId = batchId;
              var signTime = this.c_de.signTime;
              var url = "/coupon/get";
              this.receivecoupon (n,deliveryId,batchId,sign,signTime,url)
          }
      },
      //领取优惠券
      receivecoupon: function(n, deliveryId, batchId, sign, signTime, url) {
        let hdu = getCookie("hdu");
        let hdt = getCookie("hdt");
        let _this = this;
        let urlData = "";
        if (hdu) {
          if (n == 1) {
            var data = {
              id: deliveryId,
              batchIds: batchId,
              sign: sign,
              signTime: signTime,
            }
            urlData = url + "?id=" + deliveryId + "&batchIds=" + batchId + "&sign=" + sign + "&signTime=" +signTime;
          } else if (n == 2) {
            var data = {
              id: deliveryId,
              batchId: batchId,
              sign: sign,
              signTime: signTime,
            }
            urlData = url + "?id=" + deliveryId + "&batchId=" + batchId + "&sign=" + sign + "&signTime=" +signTime;
          }

          getCoupon(urlData).then((res) => {
            this.$vux.toast.text(res.data, 'middle');
            _this.getPopCouponFun();
            _this.getLaxinConfigFun();
          });
        }
      },

      // 检测是否已加好友
      findEnterpriseWeChatFun:function(){
        let hdu = getCookie("hdu");
        let that = this;
        findEnterpriseWeChat(hdu).then((res) => {
          if(res.code == 200){
            if(res.data){
              that.showWeChat = false;
              that.showBottomWeChat = false;

              // that.showOldWeChat = true;
              // that.showOldBottomWeChat = true;
              // that.imgsrc = "https://misc.reflower.com.cn/images/wximg/addWXOld1.png";
            }else{
              that.showWeChat = true;
              that.showBottomWeChat = true;

              that.showOldWeChat = false;
              that.showOldBottomWeChat = false;
              that.imgsrc = "https://misc.reflower.com.cn/images/wximg/addWX0806.png";
            }

          }
        });
      },

      //浮标加微信好友
      floatBtnClickedFun:function(){
        sa.track("addWechatClick", {
          platform_type: "H5",
          belong_page: location.href,
        	type_name:"首页浮标",
        	type_url:"https://m.reflower.com.cn/customer/#/richPage?id=5084 "
        });
        window.location.href = "https://m.reflower.com.cn/customer/#/richPage?id=5084 "

      },


      //浮标已经加微信好友
      floatBtnOldClickedFun:function(){
        sa.track("addWechatClick", {
          platform_type: "H5",
          belong_page: location.href,
        	type_name:"首页浮标",
        	type_url:"https://mp.weixin.qq.com/s/GEzJyh3PSviychghjK9n1Q"
        });
        window.location.href = "https://mp.weixin.qq.com/s/GEzJyh3PSviychghjK9n1Q"

      },

      //弹窗加微信跳转链接
      addWechatFunA: function () {
        this.showPopCoupon = false;
        sa.track("addWechatClick", {
          platform_type: "H5",
          belong_page: location.href,
        	type_name:"首页弹窗",
        	type_url:this.laxinUrl
        });
        window.location.href = this.laxinUrl;// "https://mp.weixin.qq.com/s/nHUcz8v_qKgjSVrw79bydw";// "https://mp.weixin.qq.com/s/Q8fX6ywhE70R_FD72t9IdA"
      },

      addWechatFunB: function () {
        this.showPopCoupon = false;
        sa.track("addWechatClick", {
          platform_type: "H5",
          belong_page: location.href,
        	type_name:"首页弹窗",
        	type_url:"https://mp.weixin.qq.com/s/qfe73ENIogIxXzXREgJl3g"
        });
        window.location.href = "https://mp.weixin.qq.com/s/qfe73ENIogIxXzXREgJl3g";// "https://mp.weixin.qq.com/s/nHUcz8v_qKgjSVrw79bydw";// "https://mp.weixin.qq.com/s/Q8fX6ywhE70R_FD72t9IdA"
      },

      //获取拉新图片
      getLaxinConfigFun() {
        let that = this;
        getLaxinConfig().then(res=>{
          if(res.status == 1){
            that.laxinImg = "https://img.reflower.com.cn/" + res.result.imgUrl,
            that.laxinUrl = res.result.jumpUrl
          }
        })
      },
    },
  };



// WEBPACK FOOTER //
// ./src/view/index/index.vue